import React from 'react';
import styled from 'styled-components';
import $ from 'jquery';
import moment from 'moment-timezone';
import { connect } from 'react-redux';

import posted from '../../../svg/posted.svg';
import { Row, Col } from '../../Grid';
import { formatTime } from '../../../helpers';
import { InstanceContainer, InstanceTime, CancelButton } from './Common';
import { cancelClaim } from '../../../redux/offers';
import ModalQuestion from '../../ModalQuestion';

const AttendeeName = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  line-height: 40px;
  color: #333333;
  text-decoration: underline;
`;

export const ModelStatus = styled.div`
  text-align: right;
  font-family: BrandonGrotesque-Medium;
  font-size: 14px;
  font-style: italic;
  line-height: 0.86;
  text-align: right;
  font-weight: bold;
  line-height: 46px;
  padding-right: 30px;
  color: ${(props) => props.color};
  margin-top: -3px;
`;

const AttendeeLink = styled.a`
  margin-left: 40px;
  color: #333333;
`;

export const stateText = {
  used: 'Checked in: ',
  canceled: 'Canceled: ',
  expired: 'Expired: ',
};

interface Props {
  attendee: Attendee;
  type: string;
  cancelClaim: Function;
  offerId: string;
  date: string;
  business: any;
}

const checkSameDay = (attendee, date, key) => moment(attendee[key]).isSame(moment(date), 'day');

export const correctTime = (date: string, attendee: Attendee) => {
  switch (attendee.status) {
    case 'used':
      if (checkSameDay(attendee, date, 'checked_in_at')) return formatTime(attendee.checked_in_at);
      else
        return (
          moment(attendee.checked_in_at).format('MMM D, ') + formatTime(attendee.checked_in_at)
        );
    case 'canceled':
      if (checkSameDay(attendee, date, 'canceled_at')) return formatTime(attendee.canceled_at);
      else return moment(attendee.canceled_at).format('MMM D, ') + formatTime(attendee.canceled_at);
    case 'expired':
      if (checkSameDay(attendee, date, 'expires_at')) return formatTime(attendee.expires_at);
      else return moment(attendee.expires_at).format('MMM D, ') + formatTime(attendee.expires_at);
    default:
      return null;
  }
};

export const stateColor = {
  used: '#415859',
  canceled: '#555555',
  expired: '#b71b03',
};

function ReservationSlots({ offerId, attendee, type, cancelClaim, business, date }: Props) {
  if (!attendee) return null;

  return (
    <InstanceContainer>
      <ModalQuestion
        title="Cancel Reservation?"
        leftName="NO"
        rightName="YES"
        id={'cancel' + attendee.id}
        function={() =>
          cancelClaim(attendee.offer_id || offerId, attendee.id, business.business_id, type)
        }
      >
        Are you sure you want to cancel reservation at {formatTime(attendee.reserved_for)} for{' '}
        {attendee.model.name}?
      </ModalQuestion>
      {type !== 'past' ? (
        <Row>
          <Col size="0 0 270px">
            <InstanceTime color="#b4a361">{formatTime(attendee.reserved_for)}</InstanceTime>
          </Col>
          <Col size="8">
            <AttendeeName>{attendee.model.name}</AttendeeName>
          </Col>
          <Col size={`0 0 ${attendee.status !== 'active' ? '200px' : '20px'}`}>
            {attendee.status === 'active' ? (
              <div onClick={() => $('#cancel' + attendee.id).modal('show')}>
                <CancelButton />
              </div>
            ) : (
              <ModelStatus color={stateColor[attendee.status]}>
                {stateText[attendee.status]} {correctTime(date, attendee)}
              </ModelStatus>
            )}
          </Col>
        </Row>
      ) : (
        <Row>
          <Col size="0 0 270px">
            <AttendeeName>
              <AttendeeLink
                href={attendee.model.instagram && attendee.model.instagram.profile_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {attendee.model.name}
              </AttendeeLink>
              {attendee.posted_at && <img src={posted} alt="" style={{ marginLeft: '10px' }} />}
            </AttendeeName>
          </Col>
          <Col size="1">
            <ModelStatus color={stateColor[attendee.status]}>
              {stateText[attendee.status]} {correctTime(date, attendee)}
            </ModelStatus>
          </Col>
        </Row>
      )}
    </InstanceContainer>
  );
}

export default connect(({ business }: { business: any }) => ({ business }), { cancelClaim })(
  ReservationSlots
);
